/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Point } from "../models/point";
import { METERS_TO_FEET_MULTIPLIER } from "../app-constants";

/** 
 * Display Utility Module with methods used throughout
 * the Application
 */
export class DisplayModule {

    /**
     * Returns the Display String that should be used to display
     * the given Point / Position.  Point / Position values are 
     * stored using metric / meters.  This assumes that the User wants
     * the information in IMPERIAL units (Feet / Inches).
     * @param position - Point to be translated into a 
     * human-readable string.
     */
    static getDisplayForPoint(position: Point): string {
        if (position && position.x && position.y) {
            if (position.z) {
                return this.getDisplayForMeasurement(position.x) + ", " + this.getDisplayForMeasurement(position.y) + ", " + this.getDisplayForMeasurement(position.z);
            } else {
                return this.getDisplayForMeasurement(position.x) + ", " + this.getDisplayForMeasurement(position.y);
            }
        }        
        return "*NO-POSITION*";
    }

    /**
     * Returns the Display String that should be used to display the
     * given measurement in metric / meters.  This assumes that the User 
     * wants the information in IMPERIAL units (Feet / Inches) and that 
     * incoming measurement is in metric / meters.
     * @param valueInMeters - Measurement Unit to be converted into a
     * human-readable string. 
     */
    static getDisplayForMeasurement(valueInMeters: number): string {
        if (valueInMeters == null) {
            return "";
        } else {
            //Meters => Feet
            let valueInFeet = METERS_TO_FEET_MULTIPLIER * valueInMeters;
      
            //Get the Feet
            const feet = Math.floor(valueInFeet);
            valueInFeet = valueInFeet - feet;
      
            //Get the inches
            const inches = Math.round(Math.round(valueInFeet * 1200) / 100);
      
            //Return the Feet/Inches Display
            return feet + "' " + inches + '"';
          }
    }

}
